import React from "react";
import { Col, Container, Row } from "react-bootstrap";
import { StaticImage } from "gatsby-plugin-image";

function Ressult() {
  return (
    <section className="intro_section p-100">
      <Container>
        <Row>
          <Col xs={12} md={12} lg={5} xl={5} xxl={5} className="my-auto">
            <h2 style={{ color: "#000" }}>
              The <span style={{ color: "#C92042" }}>Results</span>
            </h2>
          </Col>
          <Col
            xs={12}
            md={12}
            lg={6}
            xl={6}
            xxl={6}
            className="my-auto offset-lg-1"
          >
            <p>
              With Dream Energy Solutions we have created a website that’s
              easy-to-use, and at the same time comprehensively covers each
              aspect of client's services. From the color scheme and visual
              elements to simple and exciting animations, the website is
              designed to be appealing in every way.
            </p>
          </Col>
        </Row>
      </Container>
      <Container fluid>
        <Row>
          <Col xs={12} md={12} lg={12} xl={12} xxl={12}>
            <StaticImage
              src="../../../images/case-studies/murifield/result_img.webp"
              alt="TekRevol"
              layout="constrained"
              placeholder="blurred"
              formats={["webp"]}
              width={1481}
              height={908}
            />
          </Col>
        </Row>
      </Container>
    </section>
  );
}

export default Ressult;
